var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asd20-school-directory__map-view"},[_c('l-map',{ref:"map",attrs:{"zoom":_vm.zoom,"center":_vm.center,"options":_vm.mapOptions},on:{"update:center":_vm.centerUpdate,"update:zoom":_vm.zoomUpdate}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._l((_vm.schools),function(school){return _c('l-marker',{key:school.abbreviation,attrs:{"lat-lng":_vm.calculateSchoolLatLng(school),"options":{ riseOnHover: true }}},[_c('l-tooltip',{attrs:{"options":{ permanent: false, interactive: false, opacity: 1 }}},[_c('span',{domProps:{"innerHTML":_vm._s(
            school.title.replace(
              /(Elementary|Middle|High) School/,
              '<small>$1 School</small>'
            )
          )}})]),_c('l-popup',{attrs:{"options":{ permanent: false, interactive: true, opacity: 1 }}},[_c('h2',{domProps:{"innerHTML":_vm._s(
            school.title.replace(
              /(Elementary|Middle|High) School/,
              '<small>$1 School</small>'
            )
          )}}),_c('p',[_c('small',[_vm._v(_vm._s(school.address.street1)+", "+_vm._s(school.address.zip))])]),(
            school.feederOrganizations && school.feederOrganizations.length
          )?_c('p',[_c('strong',[_vm._v("Other Schools in this Strand:")]),_c('br'),_c('small',_vm._l((school.feederOrganizations),function(name,index){return _c('span',{key:index},[_vm._v("\n              "+_vm._s(name)),_c('br')])}),0)]):_vm._e(),_c('asd20-button',{attrs:{"size":"sm","label":"View Profile","transparent":"","bordered":""},nativeOn:{"click":function($event){return _vm.onSelect(school)}}})],1)],1)}),_c('l-circle-marker',{attrs:{"lat-lng":_vm.center,"radius":8,"options":{ color:
    '#38393e', fillColor: '#ffffff', fillOpacity: 0.8, weight: 3 }}}),(_vm.boundaryVisible && _vm.boundaryLayers.district && _vm.boundaryGeoJson)?_c('l-geo-json',{attrs:{"geojson":_vm.boundaryGeoJson,"options-style":() => ({
          color: '#3388ff',
          weight: 3,
          fillColor: '#3388ff',
          fillOpacity: 0.2,
        })}}):_vm._e(),(_vm.boundaryVisible && _vm.boundaryLayers.high && _vm.highSchoolBoundaries)?_c('l-geo-json',{attrs:{"geojson":_vm.highSchoolBoundaries,"options-style":() => ({
          color: '#00457C',
          weight: 2,
          fillColor: '#00457C',
          fillOpacity: 0.2,
        })}}):_vm._e(),(
        _vm.boundaryVisible && _vm.boundaryLayers.middle && _vm.middleSchoolBoundaries
      )?_c('l-geo-json',{attrs:{"geojson":_vm.middleSchoolBoundaries,"options-style":() => ({
          color: '#BB3E03',
          weight: 2,
          fillColor: '#BB3E03',
          fillOpacity: 0.2,
        })}}):_vm._e(),(
        _vm.boundaryVisible &&
          _vm.boundaryLayers.elementary &&
          _vm.elementarySchoolBoundaries
      )?_c('l-geo-json',{attrs:{"geojson":_vm.elementarySchoolBoundaries,"options-style":() => ({
          color: '#0EAD69',
          weight: 2,
          fillColor: '#0EAD69',
          fillOpacity: 0.2,
        })}}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }